// Feature flag: side-by-side Node Edit panel. Read once at module load so the
// value stays consistent for the entire session. Defaults ON (opt-out): a user
// who has never toggled it gets the side-by-side editor; toggle it OFF in the
// Experimental sidebar to fall back to the legacy modal. Toggling reloads the
// page because the gate is evaluated only once, here, at module load. The catch
// keeps the feature ON when localStorage is unavailable (e.g. private mode).
export const FEATURE_NODE_EDIT_SIDE_PANEL = (() => {
  try {
    return JSON.parse(localStorage.getItem('featureNodeEditSidePanel') ?? 'true') === true;
  } catch {
    return true;
  }
})();
